/**
 * Returns true when the given rich-text HTML has no meaningful content.
 * The TipTap editor serialises an empty document as "<p></p>"; treat that,
 * null/undefined, and whitespace-only markup as empty so the notes indicator
 * and the stored value stay clean.
 */
export function isNotesEmpty(html: string | null | undefined): boolean {
  if (html == null) {
    return true;
  }

  const stripped = html
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, '')
    .replace(/\s+/g, '');

  return stripped.length === 0;
}
